import { useSelector } from 'react-redux';
import CameraStreamHeaderInfo from './CameraStreamHeaderInfo';
import Intercom from 'components/transaction/components/panels/transaction/VideoWallMode/CompactMode/CameraStreamCompactHeader/Intercom/Intercom';
import AIDetection from 'components/transaction/components/panels/transaction/VideoWallMode/CompactMode/CameraStreamCompactHeader/AIDetection/AIDetection';
import AuxiliaryIndicator from 'components/transaction/components/panels/transaction/VideoWallMode/CompactMode/CameraStreamCompactHeader/AuxiliaryIndicator/AuxiliaryIndicator';
import LanePinIndicator from 'components/transaction/components/panels/transaction/stickyLanes/LanePinIndicator';
import { selectVideoWallPinnedLaneUsername } from 'store/transactionsSlice/transactionsSelectors';

import PropTypes from 'prop-types';
import styles from './CameraStreamHeader.module.css';

const CameraStreamHeader = ({
    isVideoLoading,
    videoFailedToLoad,
    camConfig,
    level1,
    expandedCamId,
    headerMode,
    videoWallTransactionNotification,
    isCompactVideoWall,
    isDetectionOn,
    isIntercomActive = false,
    hasIntercom = false,
}) => {
    const headerContainerStyles = `${styles['tc-cs-header']} ${styles['tc-cs-header--absolute']}${
        !isVideoLoading && !videoFailedToLoad ? ` ${styles['tc-cs-header--box-shadow']}` : ''
    }${expandedCamId && expandedCamId !== camConfig.id && !level1 ? ` ${styles['tc-cs-header--L2-shrinked']}` : ''} ${
        camConfig.direction === 'OUT' ? styles['header-color-out'] : styles['header-color-in']
    } ${videoWallTransactionNotification ? styles['header-color-transaction'] : ''}`;

    const title = camConfig.locationName ?? '';
    const gateName = camConfig.gateName ?? '';
    const direction = camConfig.direction ?? '';
    const assignee = videoWallTransactionNotification?.transactions?.[0]?.assignee ?? '';
    const pinnedByUsername = useSelector(selectVideoWallPinnedLaneUsername(camConfig.gateId));
    const displayName = pinnedByUsername ?? assignee;

    if (isCompactVideoWall) return null;

    return (
        <>
            {headerMode && (
                <div className={headerContainerStyles}>
                    <CameraStreamHeaderInfo title={title} gateName={gateName} direction={direction} />
                    {(pinnedByUsername || videoWallTransactionNotification) && <p className={styles['header-assigned-name']}>{displayName}</p>}
                    <div className={styles['header-indicators--wrapper']}>
                        <AuxiliaryIndicator show={camConfig.auxiliaryCamera} />
                        <AIDetection className={styles['ai-detection']} isDetectionOn={isDetectionOn} />
                        <Intercom className={styles['intercom']} isIntercomActive={isIntercomActive} show={hasIntercom} isGreyIcon />
                        <LanePinIndicator show={!!pinnedByUsername} username={pinnedByUsername} color="white" />
                    </div>
                </div>
            )}
        </>
    );
};

export default CameraStreamHeader;

CameraStreamHeader.propTypes = {
    isVideoLoading: PropTypes.bool,
    videoFailedToLoad: PropTypes.bool,
    camConfig: PropTypes.object.isRequired,
    level1: PropTypes.bool,
    expandedCamId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    headerMode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    videoWallTransactionNotification: PropTypes.object,
    isCompactVideoWall: PropTypes.bool,
    isDetectionOn: PropTypes.bool,
    isIntercomActive: PropTypes.bool,
    hasIntercom: PropTypes.bool,
};
